export default __webpack_public_path__ + "static/media/egghead.f6846957.svg";